import { default as addConfiguration } from './add';
import { default as getConfiguration } from './get';
import { default as getExportConfiguration } from './getExport';
import { default as loadMoreConfiguration } from './loadMore';

export const configurations = [
  getConfiguration,
  getExportConfiguration,
  addConfiguration,
  loadMoreConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/configurations/index.js